import { useKeycloak } from "@react-keycloak/web";
import cookie from 'react-cookies'

const PrivateRoute = ({ children }) => {
    const { keycloak } = useKeycloak();

    if(keycloak.token !== undefined){
        cookie.save('token',keycloak.token,{path: '/'})
        return children[1]
        return JSON.stringify(keycloak)
    }
    else{
        return children[0]
        return JSON.stringify(keycloak)
    }
};

export default PrivateRoute;
